import { ConservationBenchmarkType } from '@/api/rest/resources/conservation';

export const useGetConservationBenchmarks = (): Record<ConservationBenchmarkType, number> => {
  // TODO: MVP-5183 these values should be fetched from the back end
  return {
    [ConservationBenchmarkType.thriving]: 95,
    [ConservationBenchmarkType.healthy]: 75,
    [ConservationBenchmarkType.managing]: 50,
    [ConservationBenchmarkType.fragile]: 25,
    [ConservationBenchmarkType.degraded]: 0,
  };
};
